import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  UPDATE_OIB,
  AUTHORITIES,
  SET_HOST
} from "../../constants/constants";
import { REHYDRATE } from "redux-persist";

export const initialState = {
  userData: null,
  isPending: false,
  isAuthenticated: false,
  error: false,
  subjectOib: undefined,
  authority: undefined,
  host: "",
  subjectData: {
    forLegalIps: null,
    legalIzvor: null,
    personOib: null,
    toLegalIps: null,
    toLegalIzvor: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      if (action.payload) {
        return (state = {
          ...state,
          ...action.payload.authentication,
        });
      }
      return state;
    case LOGIN_REQUEST:
      return {
        ...state,
        isPending: action.isPending,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        isPending: action.isPending,
        isAuthenticated: action.isAuthenticated,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isPending: action.isPending,
        isAuthenticated: action.isAuthenticated,
        error: action.error,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        isPending: action.isPending,
      };
    case LOGOUT_SUCCESS:
      /**MAYBE JUST RETURN intialState */
      return {
        ...state,
        userData: null,
        isPending: false,
        isAuthenticated: false,
        error: false,
        subjectOib: undefined,
        authority: false,
        subjectData: initialState.subjectData,
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        isPending: action.isPending,
        isAuthenticated: action.isAuthenticated,
        error: action.error,
      };
    case UPDATE_OIB:
      return {
        ...state,
        subjectOib: action.payload,
        subjectData: {
          ...action.subjectData
        }
      };
    case AUTHORITIES:
      return {
        ...state,
        authority: action.payload,
      };
    case SET_HOST:
      return {
        ...state,
        host: action.payload
      }
    default: {
      return state;
    }
  }
};
